
import { Button } from "@/components/ui/button";
import { ArrowLeft, CreditCard, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useRecepcionistaRedirect } from "@/hooks/useRecepcionistaRedirect";

interface PageHeaderProps {
  gymId: string | null;
  gymName?: string;
}

export const PageHeader = ({ gymId, gymName }: PageHeaderProps) => {
  const navigate = useNavigate();
  const { isRecepcionista } = useRecepcionistaRedirect();

  const handleBack = () => {
    if (isRecepcionista) {
      navigate("/recepcionista");
    } else if (gymId) {
      navigate("/configuracion?tab=admin&subtab=gimnasios");
    } else {
      navigate("/configuracion?tab=admin&subtab=estadisticas");
    }
  };

  return (
    <div className="mb-8">
      <Button
        variant="ghost"
        onClick={handleBack}
        className="text-primary/70 hover:text-primary hover:bg-primary/10 -ml-2 mb-4"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        {isRecepcionista ? "Volver al Panel" : "Volver"}
      </Button>
      
      <div className="flex items-start gap-4">
        <div className="p-3 rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/10">
          <CreditCard className="h-8 w-8 text-primary" />
        </div>
        
        <div className="flex-1">
          <div className="flex items-center gap-3 flex-wrap">
            <h1 className="text-2xl sm:text-3xl font-bold text-primary">
              {gymId ? "Pagos del Gimnasio" : "Total de Pagos"}
            </h1>
            
            {gymId && gymName && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20">
                <Building2 className="h-3 w-3" />
                {gymName}
              </span>
            )}
            
            {!gymId && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20">
                Vista Global
              </span>
            )}
          </div>
          
          <p className="text-primary/60 mt-1 text-sm sm:text-base">
            {gymId 
              ? "Gestiona y visualiza todos los pagos de este gimnasio" 
              : "Gestiona y visualiza todos los pagos de la plataforma"}
          </p>
        </div>
      </div>
    </div>
  );
};
